import { useState } from "react";
import { FileText, Link2, Loader2, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const TABS = [["pdf", FileText, "PDF ou foto"], ["url", Link2, "Link do cardápio"]];

export function ImportSource({ busy, onFile, onUrl }) {
  const [tab, setTab] = useState("pdf");
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState("");
  const [over, setOver] = useState(false);
  const ready = tab === "pdf" ? !!file : url.trim().length >= 8;
  const drop = (e) => { e.preventDefault(); setOver(false); const f = e.dataTransfer.files?.[0]; if (f) setFile(f); };
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-2">
        {TABS.map(([k, Icon, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} className={cn("flex items-center justify-center gap-2 rounded-xl border p-3 text-sm font-medium transition-colors", tab === k ? "border-primary bg-primary/10 text-primary" : "hover:border-primary/40")} data-testid={`menu-import-tab-${k}`}>
            <Icon className="h-4 w-4" />{l}
          </button>
        ))}
      </div>
      {tab === "pdf" ? (
        <label onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)} onDrop={drop}
          className={cn("flex cursor-pointer flex-col items-center gap-2 rounded-xl border-2 border-dashed p-8 text-center transition-colors hover:border-primary/50", over && "border-primary bg-primary/5")} data-testid="menu-import-dropzone">
          <Upload className="h-8 w-8 text-muted-foreground" />
          <span className="text-sm font-medium" data-testid="menu-import-file-name">{file ? file.name : "Clique ou arraste o PDF ou a foto aqui"}</span>
          <span className="text-xs text-muted-foreground">PDF (com texto ou de imagem) ou foto JPG/PNG, até 15 MB. PDF de imagem e foto podem levar até 1 minuto.</span>
          <input type="file" accept="application/pdf,.pdf,image/jpeg,image/png,.jpg,.jpeg,.png" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="menu-import-file-input" />
        </label>
      ) : (
        <div className="space-y-2">
          <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://..." data-testid="menu-import-url-input" />
          <p className="text-xs text-muted-foreground">Cole o link público do cardápio digital, de outro sistema ou deste.</p>
        </div>
      )}
      <Button className="w-full" disabled={busy || !ready} onClick={() => (tab === "pdf" ? onFile(file) : onUrl(url.trim()))} data-testid="menu-import-read-btn">
        {busy ? <><Loader2 className="mr-1 h-4 w-4 animate-spin" />Lendo o cardápio...</> : "Ler cardápio"}
      </Button>
    </div>
  );
}
